export enum ChargebackStatus {
    'all' = '',
    'chargeback' = 'chargeback',
    'chargeback-reversal' = 'chargeback-reversal',
    'second-chargeback-lost' = 'second-chargeback-lost'
}
